import React from 'react';

import _ from 'lodash';
import classnames from 'classnames';
import Skeleton from 'react-loading-skeleton';

import Button from 'shared/components/Button';
import Image from 'shared/components/Image';

import { truncateText } from 'shared/utils/truncateText';
import defaultLogo from 'assets/images/default_logo.svg';

import styles from './styles.module.scss';

const Placeholder = ({
  count = 1,
  className,
  imageData: { height = 50, width = 50 }
}) =>
  _.range(count).map(index => (
    <div
      key={`home-company-box-placeholder-${index}`}
      className={classnames(
        styles.imageBoxWrapper,
        styles.placeholder,
        className
      )}>
      <Skeleton
        className={styles.imageContainer}
        width={width}
        height={height}
      />
      <div className={styles.title}>
        <Skeleton />
      </div>
      <div className={styles.divider} />
      <div className={styles.headlineAndBtnWrapper}>
        <div className={styles.headline}>
          <Skeleton count={4} />
        </div>
        <Button color="primary" className={styles.btn} disabled={true}>
          Find out more
        </Button>
      </div>
    </div>
  ));

let HomeCompanyBox = ({
  title,
  label,
  headline,
  handleClick,
  className,
  imageData: {
    image = null,
    thumbnails = [],
    width = 50,
    height = 50,
    defaultImage = defaultLogo
  }
}) => {
  return (
    <div
      className={classnames(styles.imageBoxWrapper, className)}
      onClick={handleClick}>
      <Image
        className={styles.imageContainer}
        src={image}
        thumbnails={thumbnails}
        width={width}
        height={height}
        defaultImage={defaultImage}
      />
      <div className={styles.title} title={title}>
        {title}
      </div>
      <div
        className={styles.label}
        dangerouslySetInnerHTML={{ __html: label }}
      />
      <div className={styles.divider} />
      <div className={styles.headlineAndBtnWrapper}>
        <div className={styles.headline}>{truncateText(headline, 125)}</div>
        <Button color="primary" className={styles.btn}>
          Find out more
        </Button>
      </div>
    </div>
  );
};

HomeCompanyBox.Placeholder = Placeholder;

export default HomeCompanyBox;
